import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import AiraChatBody from "./AiraChatBody";

const AiraChatPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <AiraChatBody />
      </div>
    </main>
  );
};

export default AiraChatPage;
